export const SITE_SEARCH_ROUTE = '/search';
export const SEARCH_TERM_PARAM = 'q';
export const OFFSET_PARAM = 'offset';
export const DOCUMENT_TYPE_PARAM = 'documentType';
export const ORGANISM_PARAM = 'organisms';
export const FILTERS_PARAM = 'filters';
